import { LoadingCard } from "../card";

export function LoadingSolutions({number}) {
    return <div className="solutions-grid solutions-container">
        {[...Array(number)].map((_, index) => <LoadingCard key={index} height={600}/>)}
    </div>;
}